<template lang="pug">
  .email-capture-footer-form
    .title.upper.cta-color-2.bold.mb-10 {{ title }}

    p.description(v-if="isCustomerHardAuthenticated") You're already subscribed

    p.description(v-else-if="subscribed") You're on the list!

    template(v-else)
      p.description For exclusive promotions, news & events.

      p.description.xs-pb-50m Plus, get&nbsp;
        span.bold free shipping
        | &nbsp;on your first order!

      transition(name="fade")
        EmailCaptureForm(type="banner")
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import EmailCaptureForm from '../EmailCaptureForm';

  export default {
    name: 'EmailCaptureFooterForm',

    components: {
      EmailCaptureForm,
    },

    computed: {
      title() {
        if (this.subscribed || this.isCustomerHardAuthenticated) {
          return 'THANKS FOR SUBSCRIBING!';
        }
        return 'SIGN UP FOR OUR NEWSLETTER';
      },

      ...mapGetters('customer', [
        'isCustomerHardAuthenticated',
      ]),

      ...mapState('emailCapture', [
        'subscribed',
      ]),
    },
  };
</script>

<style lang="stylus">
  .email-capture-footer-form
    padding 0 2em
    display inline-flex
    flex-direction column
    text-align left

    .email-form
      overflow hidden

      button
        padding 4px
        width 100%
        height 100%
        border-radius 4px

      .loading
        padding 4px
        width 100%
        height 100%
        vertical-align center
        display flex
        align-items center
        justify-content center

        img
          width 20px
          height 20px

    .description
      margin 2px 0

  @media mq-mobile
    .email-capture-footer-form
      width 100%
      padding 2em 0em 0em 0em
</style>